export const getIndexName = (index: number): string => {
  switch (index) {
    case 0:
      return 'appuntamenti'
    case 1:
      return 'dove'
    case 2:
      return 'quando'
    case 3:
      return 'i-miei-dati'
    case 4:
      return 'conferma'
    default:
      return 'appuntamenti'
  }
}
